import { Typography } from '@mui/material';
import { DevPlanUsersListViewMode } from 'generated/CoreApi_v1';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DevPlanListFilter, DevPlansBaseList } from 'views/lms/devPlan/Home/List/DevPlansBaseList';

////////////////////////////////////////////////////////////////////////////

export const AllDevPlans: React.FC = () => {

    const { t } = useTranslation("lms");

    const [filter, setFilter] = useState<DevPlanListFilter>({
        searchText: "",
        advFilters: [],
        pageNumber: 1,
        order: null
    });

    ///
    const handleChangeFilter = (pFilter: Partial<DevPlanListFilter>) => {
        setFilter(state => ({ ...state, ...pFilter }));
    };

    return (
        <DevPlansBaseList
            headerTitle={<Typography variant="h3">{t("DevPlan.List.AllPlansTabTitle")}</Typography>}
            filter={filter}
            onChangeFilter={handleChangeFilter}
            viewMode={DevPlanUsersListViewMode.All}
        />
    );
};
